module.exports = __webpack_public_path__ + "img/5-3.719149d4.svg";